import script from "./EntitlementsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EntitlementsTable.vue?vue&type=script&setup=true&lang=js"

import "./EntitlementsTable.vue?vue&type=style&index=0&id=802417a8&scoped=true&lang=css"
import "./EntitlementsTable.vue?vue&type=style&index=1&id=802417a8&scoped=true&lang=css"
script.__scopeId = "data-v-802417a8"

export default script